import React, { useCallback } from 'react';

import { ConnectedInsightFeedback } from './ConnectedInsightFeedback';

/**
 * Returns a render function suitable for InsightsPanel's renderFeedback prop.
 * When artifactId is null (e.g. insights not yet loaded), the renderer returns null.
 */
export function useInsightFeedbackRenderer(
  artifactId: string | null,
  appointmentId: string,
): (metadata: Record<string, unknown>) => React.ReactNode {
  return useCallback(
    (metadata: Record<string, unknown>) => {
      if (!artifactId) return null;
      return React.createElement(ConnectedInsightFeedback, {
        artifactId,
        metadata,
        appointmentId,
      });
    },
    [artifactId, appointmentId],
  );
}
